<template>
<form action="" method="get" class="login-form login-form--blue">

  <div class="o-layout u-mb">
    <div class="o-layout__item u-1/2@desktop u-1/3@wide">
      <div class="login-form__input u-mb">
        <label for="username">Usuario: </label>
        <input class="u-pv-tiny" type="text" name="username" id="username" :value="user.username" required>
      </div>
    </div>
    <div class="o-layout__item u-1/2@desktop u-1/3@wide">
      <div class="login-form__input u-mb">
        <label for="name">Nombre y apellido: </label>
        <input class="u-pv-tiny" type="text" name="name" id="name" :value="user.name">
      </div>
    </div>
    <div class="o-layout__item u-1/2@desktop u-1/3@wide">
      <div class="login-form__input u-mb">
        <label for="email">Email: </label>
        <input class="u-pv-tiny" type="email" name="email" id="email" :value="user.email" required>
      </div>
    </div>
    <div class="o-layout__item u-1/2@desktop u-1/3@wide">
      <div class="login-form__input u-mb">
        <label for="address">Dirección: </label>
        <input class="u-pv-tiny" type="text" name="address" id="address" :value="user.address && userAddress">
      </div>
    </div>
    <div class="o-layout__item u-1/2@desktop u-1/3@wide">
      <div class="login-form__input u-mb">
        <label for="phone">Teléfono: </label>
        <input class="u-pv-tiny" type="phone" name="phone" id="phone" :value="user.phone">
      </div>
    </div>
  </div>

  <div class="o-layout o-layout--right o-layout--auto">
    <div class="o-layout__item">
      <button class="btn btn--primary" @click.prevent="$router.push({ name: 'userIndex' })">Cancelar</button>
    </div>
  </div>

</form>
</template>

<script>
export default {
  name: 'userForm',

  props: {
    user: { type: Object, default: Object }
  },

  computed: {
    userAddress() {
      return `${this.user.address.street} ${this.user.address.suite} (${this.user.address.city})`
    }
  }
}
</script>
